<div class="wrap">
  <button class="close-button" (click)="closeDialog()"><span class="icon-close"></span></button>
  <header>
    <h3 class="heading">
      <span *ngIf="data.action === CardActions.SUBSCRIBE" class="heading-text">
        {{ 'pages.userRecords.card.requestDetailsDialog.header' | translate }}
      </span>
      <span *ngIf="data.action === CardActions.RENEW" class="heading-text">
        {{ 'pages.userRecords.card.requestDetailsDialog.header-renewal' | translate }}
      </span>
      <span *ngIf="data.action === CardActions.LINK" class="heading-text">
        {{ 'pages.userRecords.card.requestDetailsDialog.header-link' | translate }}
      </span>
    </h3>
  </header>
  <app-user-card-not-connected-form
    [data]="data"
    (closeDialog)="closeDialog()"
  ></app-user-card-not-connected-form>
</div>